document.addEventListener('DOMContentLoaded', function () {

  const announcementSwiper = new Swiper('.mySwiper', {

    direction: 'vertical',
    loop: true,
    slidesPerView: 1,
    allowTouchMove: false,
    autoHeight: false,
    speed: 600,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: '.ann-next',
      prevEl: '.ann-prev',
    },

  });

  new Swiper('.pdpFeatureSwiper', {
    loop: false,
    speed: 800,
    spaceBetween: 0,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    pagination: {
        el: '.fi-swiper-pagination',
        clickable: true,
      },

    breakpoints: {
      0: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      }
    }
  });

  


});

jQuery(document).ready(function ($) {

  let box = $("#box");
  let imgs = $("#box img");

  // DOT CLICK (Vertical)
  $(".dot").click(function () {

    let index = $(this).data("index");

    let target = imgs.eq(index);

    let scrollTo = target[0].offsetTop;

    box.animate({
      scrollTop: scrollTo
    }, 500);

    $(".dot").removeClass("active");
    $(this).addClass("active");

  });

  // MOBILE THUMB CLICK (Horizontal)
  $(".thumb").click(function () {

    let index = $(this).data("index");

    let target = imgs.eq(index);

    let scrollTo = target[0].offsetLeft;

    box.animate({
      scrollLeft: scrollTo
    }, 500);

    $(".thumb").removeClass("active");
    $(this).addClass("active");

  });

  // ACTIVE ON SCROLL
  box.on("scroll", function () {

    let scrollTop = $(this).scrollTop();
    let scrollLeft = $(this).scrollLeft();

    imgs.each(function (i) {

      // Vertical Active
      if (scrollTop >= this.offsetTop - 200) {

        $(".dot").removeClass("active");
        $(".dot").eq(i).addClass("active");

      }

      // Horizontal Active
      if (scrollLeft >= this.offsetLeft - 100) {

        $(".thumb").removeClass("active");
        $(".thumb").eq(i).addClass("active");

      }

    });

  });

});


document.addEventListener("DOMContentLoaded", () => {

  const slider = document.querySelector(".style-slider");

  if (!slider) return;

  const next = document.querySelector(".style-next");
  const prev = document.querySelector(".style-prev");

  function updateButtons() {
    prev.disabled = slider.scrollLeft <= 0;

    next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
  }

  next.addEventListener("click", () => {

    slider.scrollBy({
      left: 300,
      behavior: "smooth"
    });

  });

  prev.addEventListener("click", () => {

    slider.scrollBy({
      left: -300,
      behavior: "smooth"
    });

  });

  slider.addEventListener("scroll", updateButtons);

  updateButtons();

});


document.addEventListener("click", function(e){

  const btn = e.target.closest(".wishlist-btn");

  if(!btn) return;

  e.preventDefault();

  btn.classList.toggle("active");

});
